import { Configuration } from 'ohzi-core';

import ApplicationView from './common/ApplicationView';
//import PhysicalCameraManager from '/js/components/PhysicalCameraManager';
//import MenuCameraManager from '../MenuCameraManager';
import LiveMode from './menu_view_mode/LiveMode';
import RecordingsMode from './menu_view_mode/RecordingsMode';
import ArchiveMode from './menu_view_mode/ArchiveMode';
import EventsMode from './menu_view_mode/EventsMode';
//import RoleManager from '../RoleManager';
import MenuSearch from './MenuSearch';
/*
import TaglockMarkerManager from '/js/components/TaglockMarkerManager';
import PlayerMarkerManager from '../PlayerMarkerManager';
import PlayerSettings from '/js/components/PlayerSettings';
import RecordingsListRowManager from '../RecordingsListRowManager';
import EventsListRowManager from '../EventsListRowManager';
//import AxisTrackerData from '/js/components/AxisTrackerData';
import LocalFileManager from '/js/components/LocalFileManager';
*/

/**
 *  @class MenuView
 *  @description This class is responsible for the display of the main menu of the application
 *  @function fill_menu() - @description populating the menu view with camera objects
 *  @function add_camera() - @description add camera to the menu view
 *  @function selectTab() -  @description Change active tab on click.Called from api.js
 *  @function select_camera() - @description Sets selected camera on click.Called by MenuCamera
 *  @function select_camera_in_menu() - @description When a user selects a camera,removes or add several html elemnet from the ui
 *  @function close() - @description Closes the side menu,when the menu is closed all menu cameras are paused.
 *  @function open() - @description Open the side menu, when the menu is opened all menu cameras are playing. The selected camera is paused in the menu.
 */

// This represents the menu panel that contains the live and recordings section.
export default class MenuView extends ApplicationView
{
  constructor(app)
  {
    super('menu', $('.menu'));

    this.app = app;
    this.cameras_index = 0;
    this.is_opened = true;
    this.nested_click = false;

    this.cameras_per_page = 6;
    this.last_camera_index = [0];
    this.menu_index = 0;

    this.ptz_interval_ms = 200;
    this.ptz_relative_move_delta = 1.5;
    this.ptz_relative_zoom_delta = 200.0;

    this.search = new MenuSearch(app, this);

    this.tabs = {
      LIVE: new LiveMode(),
      RECORDINGS: new RecordingsMode(),
      ARCHIVE: new ArchiveMode(),
      EVENTS: new EventsMode()
    };
  }

  start()
  {
    //MenuCameraManager.start();

    this.close_button = $('.menu__buttons-close');
    this.open_button = $('.menu__buttons-open');
    this.options_button = $('.menu__buttons-options');
    this.menu_cameras_container = $('.menu__cameras');
    this.tabs_tab = $('.menu__tabs-tab');
    this.tabs_tab_live = $('.menu__tabs-tab--live');
    this.tabs_tab_recordings = $('.menu__tabs-tab--recordings');
    this.tabs_tab_archive = $('.menu__tabs-tab--archive');
    this.tabs_tab_events = $('.menu__tabs-tab--events');
    this.menu_handle = $('.menu__handle');
    this.pagination_dots = $('.menu__pagination-dots');
    this.pagination_dot_template = $('.menu__pagination-dot').clone();

    if (!Configuration.is_mobile && !this.app.mode_multi_camera)
    {
      // Disable by default. Check uiShowOptions parameters from Tracker App
      //this.options_button.removeClass('hidden');
      this.container.css('width', localStorage.getItem('menu_width'));
    }
    // GG Always show menu
    //this.options_button.removeClass('hidden');
    if (this.app.start_mode_from_c2)
    {
      //this.hide();
      this.close();
    }

    this.search.start();

    this.current_tab = this.tabs.LIVE;

    this.menu_camera = $('.menu__cameras-camera');

    if (this.app.mode_multi_camera)
    {
      this.cameras_per_page = 20;
    }

    //this.fill_menu(0);

    this.menu_handle.on('mousedown touchstart', this.__on_mouse_down.bind(this));
  }

  // Called from GUI close menu button
  close_btn()
  {
    if (!this.app.menu_options_view.keep_menu_visible)
    {
      this.close();

      if (this.app.mode_multi_camera && !PhysicalCameraManager.selected_camera && !TaglockMarkerManager.is_taglock_selected())
      {
        setTimeout(function() {
          if (this.app.mode_nga)
          {
            // In NGA fly to a specific orientation (not implemented yet)
            this.app.cesium_handler.fly_to_entities();
          }
          else
          {
            this.app.cesium_handler.fly_to_entities();
          }
        }.bind(this), 1000);
      }
    }
  }

  // Closes the menu panel
  close()
  {
    if (!this.app.menu_options_view.keep_menu_visible)
    {
      this.is_opened = false;
      this.container.addClass('closed');

      if (this.app.menu_options_view.show_thumbnail_video)
      {
        //MenuCameraManager.stop_all_cameras();
      }
    }
  }

  // Opens the menu panel
  open()
  {
    // Close other menus
    this.app.uav_view?.close();
    this.app.pharos_view?.close();

    this.is_opened = true;
    this.container.removeClass('closed');

    if (this.app.menu_options_view.show_thumbnail_video)
    {
      //MenuCameraManager.play_all_cameras();
    }

    //let selected_camera = PhysicalCameraManager.selected_camera;

    if(selected_camera)
    {
      let menu_camera = MenuCameraManager.get_by_name(selected_camera.name);
      menu_camera.pause();
    }

    if (Configuration.is_mobile)
    {
      this.app.player_container.hide();
    }
  }

  // The tab refers to live, reordings or archive
  select_tab(tab, tab_el)
  {
    this.menu_cameras_container.removeClass('hidden');
    this.tabs_tab.removeClass('selected');

    this.app.calendar_view.hide();
    this.app.recordings_list_view.hide();
    this.app.events_list_view.hide();

    $('.menu__selected-camera').addClass('hidden');
    //LocalFileManager.hide_import();
    //LocalFileManager.hide_delete_options();
    $('.menu__pagination').removeClass('hidden');
    $(tab_el).addClass('selected');

    this.current_tab = tab;

    this.app.player_container.hide();

    tab.on_tab_selected(this.app.menu_view);
  }

  open_settings()
  {
    this.app.camera_settings_view.show();
    this.hide();
  }

  // Called from GUI menu options - Perform Camera Heading Calibration
  open_camera_calibration()
  {
    this.app.camera_calibration_view.show();
    this.hide();
  }

  // Called from GUI menu options - Perform Fisheye Camera Location Calibration
  open_location_calibration()
  {
    this.app.camera_location_calibration_view.set_mode(1);
    this.app.camera_location_calibration_view.start_calibration();
    this.hide();
  }

  // Called from GUI menu options - Perform PTZ Camera Location Calibration
  open_ptz_location_calibration()
  {
    this.app.camera_location_calibration_view.set_mode(2);
    this.app.camera_location_calibration_view.start_calibration();
    this.hide();
  }

  logout()
  {
    this.app.logout_in_progress = true;
    //RoleManager.logout();
    window.location.href = '/logout';
  }

  // This is called when a camera is selected in one of the tabs.
  // It will set up the cesium location and player video.
  select_camera(camera_el, e)
  {
    console.log(`[select_camera]`)
    if (!this.nested_click)
    {
      let camera_name = $(camera_el).data('name');
      //let camera = PhysicalCameraManager.get_by_name(camera_name);

      if (camera) // && camera.is_online
      {
        // Check if a ROI video thumbnail was selected
        // className: "menu__cameras-camera-roi"
        if (camera_el.className == 'menu__cameras-camera-roi')
        {
          console.log(`[select_camera] ROI thumbnail selected.`);
          camera.view_roi = true;
        }

        //if (this.app.mode_multi_camera)
        if (this.app.menu_options_view.c2_launch_standalone)
        {
          PhysicalCameraManager.selected_camera = camera;
          this.current_tab.on_camera_selected(this);
          if (this.current_tab == this.tabs.ARCHIVE)
          {
            this.select_physical_camera(camera);
          }
        }
        else
        {
          this.select_physical_camera(camera);
        }
      }
    }
    else
    {
      this.nested_click = false;
    }
  }

  // This is called when a camera map view switch is clicked
  // This will toggle the video plane on the map for mobile (webRTC) devices
  toggle_map_view_mode(camera_el, e)
  {
    this.nested_click = true;

    console.log('[MenuView:toggle_map_view_mode]');

    let camera_name = $(camera_el).data('name');
    let camera = PhysicalCameraManager.get_by_name(camera_name);

    if (camera)
    {
      let last_state = camera_el.classList.contains('active');

      this.__toggle_switch_elem(camera_el, !last_state);

      if (last_state)
      {
        console.log('[MenuView:toggle_map_view_mode] hide marker');
        // Hide the map marker plane only
        camera.map_marker.hide(true);
      }
      else
      {
        console.log('[MenuView:toggle_map_view_mode] show marker');
        // Hide the map marker plane only
        camera.show_map_marker(false);
      }
      camera.map_marker.update_arrow_text_position();
    }
  }

  // This is called when a play overlay button is clicked
  // This will play the video in the thumbnail
  toggle_play(camera_el, e)
  {
    this.nested_click = true;

    let camera_name = $(camera_el).data('name');
    let camera = PhysicalCameraManager.get_by_name(camera_name);

    if (camera)
    {
      let menu_camera = MenuCameraManager.get_by_name(camera.name);

      if (menu_camera)
      {
        //console.log('[MenuView:toggle_play] Play thumbnail video');
        menu_camera.start_streaming();
      }

    }
  }

  // This is called when a pause overlay button is clicked
  // This will pause the video in the thumbnail
  toggle_pause(camera_el, e)
  {
    this.nested_click = true;

    console.log('[MenuView:toggle_pause]');

    let camera_name = $(camera_el).data('name');
    let camera = PhysicalCameraManager.get_by_name(camera_name);

console.dir(camera);
    if (camera)
    {
      let menu_camera = MenuCameraManager.get_by_name(camera.name);

       console.dir(menu_camera);
      if (menu_camera)
      {
        console.log('[MenuView:toggle_pause] Pause thumbnail video');
        menu_camera.pause();
        //menu_camera.stop();
      }

    }
  }

  show_calendar_view()
  {
    MenuCameraManager.stop_all_cameras();
    
    // Clear all event and recordings for this camera when selecting camera in each menu. 
    this.app.calendar_view.clear_calendar_data();
    this.menu_cameras_container.addClass('hidden');

    this.app.calendar_view.show();
    $('.menu__selected-camera').removeClass('hidden');
    if (this.current_tab == this.tabs.ARCHIVE) {
      // Only show the USB import video options if enabled from the /admin page. Import not valid on AWS
      if (this.app.multi_camera_manager.param_config.player_import_enable == '1') {
        LocalFileManager.show_import();
      }
      LocalFileManager.show_delete_options();
    }
    

    $('.menu__selected-camera').text(`Selected camera: ${PhysicalCameraManager.selected_camera.name}`);
    $('.menu__pagination').addClass('hidden');
  }

  hide_calendar_view()
  {
    this.menu_cameras_container.removeClass('hidden');

    this.app.calendar_view.hide();
    this.app.recordings_list_view.hide();

    $('.menu__selected-camera').addClass('hidden');
    LocalFileManager.hide_import();
    LocalFileManager.hide_delete_options();

    //$('.menu__selected-camera').text(`Selected camera: ${PhysicalCameraManager.selected_camera.name}`);
    $('.menu__pagination').removeClass('hidden');
  }

  show_recordings_list_view()
  {
    this.app.recordings_list_view.show();
  }

  show_events_list_view()
  {
    this.app.events_list_view.show();
  }

  // This will set up the camera video elements being displayed on the menu
  fill_menu(offset, filter = '')
  {
    this.menu_index += offset;

    let max_pages = Math.ceil(PhysicalCameraManager.cameras.length / this.cameras_per_page);
    this.menu_index = THREE.Math.clamp(this.menu_index, 0, max_pages - 1);

    if (this.menu_index > 0)
    {
      this.cameras_index = this.last_camera_index[this.menu_index - 1] + 1;
    }
    else
    {
      this.cameras_index = 0;
    }
    // console.log(`[MenuView:fill_menu] max pages: ${max_pages}, menu_index: ${this.menu_index}, offset: ${offset}, cameras_index: ${this.cameras_index}`);

    if (this.cameras_index <= PhysicalCameraManager.cameras.length - 1)
    {
      MenuCameraManager.clear();
      this.pagination_dots.empty();

      this.cameras_index = THREE.Math.clamp(this.cameras_index, 0, PhysicalCameraManager.cameras.length);

      let num_cameras = 0;
      let i = 0;

      // for (let i = 0; i < PhysicalCameraManager.cameras.length; i++) {
      //   const camera = PhysicalCameraManager.cameras[i];

      // }

      let sorted_cameras = this.get_sorted_cameras();

      if (this.app.mode_multi_camera)
      {
        let camera_start_delay = this.app.menu_options_view.show_thumbnail_video ? 200 : 200;
        this.add_menu_camera_list(sorted_cameras, 0, sorted_cameras.length, num_cameras, filter, camera_start_delay);
      }
      else
      {
        while ((i + this.cameras_index) < sorted_cameras.length)
        {
          let physical_camera = sorted_cameras[i + this.cameras_index];

          // console.log(`[MenuView:fill_menu] Checking if we should add camera[${i}]: ${physical_camera.name}`);

          // if (physical_camera && (physical_camera.bodyworn !== 'yes' || this.app.menu_view.current_tab.name === 'archive'))
          if (physical_camera)
          {
            //console.log({physical_camera});
            // console.log(`[MenuView:fill_menu] Adding Menu camera: ${physical_camera.name}`);

            if (this.current_tab.is_valid_camera(physical_camera) && physical_camera.name.toLowerCase().includes(filter.toLowerCase()))
            {
              this.add_camera(physical_camera);
              num_cameras++;
              this.last_camera_index[this.menu_index] = i + this.cameras_index;
            }
          }

          if (num_cameras >= this.cameras_per_page)
          {
            break;
          }
          i++;
        }
      }

      this.add_pagination_dots();
    }
  }

  /*
  Add a list of cameras to the menu with a delay between each (for proxy server to handle connection)
  */
  add_menu_camera_list(cameras, index, length, num_cameras, filter, delay) {
    //console.log(`[add_menu_camera_list] Add index [${index}/${length}] with delay ${delay}ms`);

    if (index >= length)
    {
      return;
    }

    let physical_camera = cameras[index + this.cameras_index];

    // if (physical_camera && (physical_camera.bodyworn !== 'yes' || this.app.menu_view.current_tab.name === 'archive'))
    if (physical_camera)
    {
      if (this.current_tab.is_valid_camera(physical_camera) && physical_camera.name.toLowerCase().includes(filter.toLowerCase()))
      {
        this.add_camera(physical_camera);
        num_cameras++;
        this.last_camera_index[this.menu_index] = index + this.cameras_index;
      }
    }

    if (num_cameras >= this.cameras_per_page)
    {
      return;
    }
    index++;

    setTimeout(function() { 
      this.add_menu_camera_list(cameras, index, length, num_cameras, filter, delay);
    }.bind(this), delay);
  }

  // TODO: Move to PhysicalCameraManager
  get_sorted_cameras()
  {
    return PhysicalCameraManager.cameras.sort(function(a, b)
    {
      return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  add_pagination_dots()
  {
    let dots_amount = Math.ceil(PhysicalCameraManager.cameras.length / this.cameras_per_page);

    for (let i = 0; i < dots_amount; i++)
    {
      let active_dot_index = Math.floor(this.cameras_index / this.cameras_per_page);
      let new_dot = this.pagination_dot_template.clone();

      if (active_dot_index === i)
      {
        new_dot.addClass('active');
      }

      this.pagination_dots.append(new_dot);
    }
  }

  add_camera(physical_camera)
  {
    // console.log(`[MenuView:add_camera] Name: ${physical_camera.name}, ROI: ${physical_camera.live_camera}`);
    // console.dir(physical_camera);
    let menu_camera = MenuCameraManager.add_camera(physical_camera);

    // console.dir(menu_camera);
    if (menu_camera)
    {
      /* if (physical_camera.bodyworn === `yes` &&)
      {
        //console.log(`[MenuView:add_camera] Hiding bodyworn menu camera`);
        menu_camera.hide();
      } */

      if (this.app.menu_options_view.show_thumbnail_video)
      {
        menu_camera.start_streaming();
      }

      if (this.app.menu_options_view.show_thumbnail_image)
      {
        if (physical_camera.stream.type == 'axis')
        {
          menu_camera.show_video_image();
        }
        else
        {
          menu_camera.start_streaming(true);
        }
        menu_camera.start_streaming_metadata();
      }
      if (!physical_camera || (physical_camera && physical_camera.lens_type === 'flat'))
      {
        this.hide_camera_fisheye_frame(physical_camera.name);
      }

      //if (!this.app.mode_multi_camera && physical_camera.live_camera !== '')
      if (physical_camera.live_camera && physical_camera.live_camera !== '')
      {
        this.add_flat_view(physical_camera);
      }
    }
  }

  // Add ROI flat view to menu
  add_flat_view(physical_camera)
  {
    console.log(`[add_flat_view]`);

    let flat_camera = MenuCameraManager.add_flat_view(physical_camera);

    // console.dir(flat_camera);
    if (flat_camera)
    {
      //if (this.app.menu_options_view.show_thumbnail_video)
      if (true)
      {
        flat_camera.start_streaming();
      }

      if (this.app.menu_options_view.show_thumbnail_image)
      {
        //flat_camera.start_streaming(true);
      }
      this.hide_camera_roi_fisheye_frame(physical_camera.name);
    }
  }

  // Called from GUI menu_camera_roi joystick svg
  pan_right_fine()
  {
    this.nested_click = true;

    this.send_ptz_relative_pan(this.ptz_relative_move_delta);
    this.ptz_interval_id = setInterval(this.send_ptz_relative_pan.bind(this, this.ptz_relative_move_delta), this.ptz_interval_ms);
  }

  // Called from GUI menu_camera_roi joystick svg
  pan_left_fine()
  {
    this.nested_click = true;

    this.send_ptz_relative_pan(-this.ptz_relative_move_delta);
    this.ptz_interval_id = setInterval(this.send_ptz_relative_pan.bind(this, -this.ptz_relative_move_delta), this.ptz_interval_ms);
  }

  // Called from GUI menu_camera_roi joystick svg
  tilt_up_fine()
  {
    this.nested_click = true;

    this.send_ptz_relative_tilt(this.ptz_relative_move_delta);
    this.ptz_interval_id = setInterval(this.send_ptz_relative_tilt.bind(this, this.ptz_relative_move_delta), this.ptz_interval_ms);
  }

  // Called from GUI menu_camera_roi joystick svg
  tilt_down_fine()
  {
    this.nested_click = true;

    this.send_ptz_relative_tilt(-this.ptz_relative_move_delta);
    this.ptz_interval_id = setInterval(this.send_ptz_relative_tilt.bind(this, -this.ptz_relative_move_delta), this.ptz_interval_ms);
  }

  // Called from GUI menu_camera_roi joystick svg
  ptz_mouse_up()
  {
    clearInterval(this.ptz_interval_id);
  }

  // Called from GUI menu_camera_roi.pug
  zoom_in_down()
  {
    this.nested_click = true;

    this.send_ptz_relative_zoom(this.ptz_relative_zoom_delta);
    this.ptz_zoom_interval_id = setInterval(this.send_ptz_relative_zoom.bind(this, this.ptz_relative_zoom_delta), 200);
  }

  // Called from GUI menu_camera_roi.pug
  zoom_out_down()
  {
    this.nested_click = true;

    this.send_ptz_relative_zoom(-this.ptz_relative_zoom_delta);
    this.ptz_zoom_interval_id = setInterval(this.send_ptz_relative_zoom.bind(this, -this.ptz_relative_zoom_delta), 200);
  }

  // Called from GUI menu_camera_roi.pug
  ptz_zoom_mouse_up()
  {
    clearInterval(this.ptz_zoom_interval_id);
  }

  send_ptz_relative_pan(pan)
  {
    this.send_ptz_generic(`rpan=${pan}`);
  }

  send_ptz_relative_tilt(tilt)
  {
    this.send_ptz_generic(`rtilt=${tilt}`);
  }

  send_ptz_relative_zoom(zoom) {
    this.send_ptz_generic(`rzoom=${zoom}`);
  }

  send_ptz_generic(generic_params) {
    let camera = PhysicalCameraManager.cameras[0];
    
    console.dir(`[send_ptz_generic] ${generic_params}`);
    //console.dir(camera);

    /*let api_host = `http://${camera.recordings_ip}`;
    //console.log(`[send_ptz_generic] api_host: ${api_host}`);

    $.ajax({
      type: 'GET',
      url: `${api_host}/axis-cgi/com/ptz.cgi?${generic_params}&camera=${camera.live_camera}`,
      timeout: 2000,
    });
*/
    let generic_url = `/axis-cgi/com/ptz.cgi?${generic_params}&camera=${camera.live_camera}`;

console.dir(`[send_ptz_generic] generic_url: ${generic_url}`);
    
    this.app.axis_tracker_data_controller.generic_request_proxy(camera, generic_url,  function(scope, res) {
       console.log(`[send_ptz_generic] callback`);
       console.dir(res);

      // Handle errors
      if (res.status !== 200 && !this.app.dev_env)
      {
        console.warn(`MenuView generic request error: ${res.responseText}`);
        console.dir(res);
        return;
      }

      let responseData = res.responseText;

      
    }, this);
  }

  select_physical_camera(camera)
  {
    console.log(`[select_physical_camera] tab: ${this.current_tab.name}`);
    this.select_camera_in_menu(camera.name);
    //TaglockMarkerManager.hide_select_taglock();

    if(PhysicalCameraManager.selected_camera)
    {
      PhysicalCameraManager.selected_camera.stop_streaming();
    }

    if (this.current_tab == this.tabs.LIVE && !TaglockMarkerManager.is_taglock_selected())
    {
      //PlayerSettings.set_map_lock();
      PhysicalCameraManager.set_active_camera(camera);
    }
    else
    {
      PhysicalCameraManager.set_active_camera(camera, true);  // Don't fly to camera location
    }

    this.app.player_container.show_loading();

    if (this.app.menu_options_view.show_thumbnail_video)
    {
      MenuCameraManager.play_all_cameras();
    }
    
    let menu_camera = MenuCameraManager.get_by_name(camera.name);
    if (menu_camera)
    {
      if (camera.lens_type === 'fisheye')
      {
        camera.map_marker.set_image_url(menu_camera.stream.get_screenshot_url());
        // this.app.player_settings.hide_lockview_all_axis_target();
      }
      menu_camera.pause();
    }
  
    this.app.camera_settings_view.fill_hotspot_select();
    PlayerMarkerManager.reset_temp_camera();

    //this fuction is called triggers the play of the video
    this.current_tab.on_camera_selected(this);
  }

  select_camera_in_menu(camera_name)
  {
    let camera_el = $(`.menu__cameras-camera[data-name='${camera_name}']`);

    $('.menu__cameras-camera__container').removeClass('selected');
    $('.menu__cameras-camera-image-img').removeClass('selected');
    $(camera_el).find('.menu__cameras-camera__container').addClass('selected');
    $(camera_el).find('.menu__cameras-camera-image-img').addClass('selected');

    // Set map_view button on
    $(camera_el).find('.menu__cameras-camera-map_view').addClass('active');
  }

  hide_camera_fisheye_frame(camera_name)
  {
    let camera_el = $(`.menu__cameras-camera[data-name='${camera_name}']`);

    $(camera_el).find('.menu__cameras-camera-image-img').addClass('invisible');
  }

  hide_camera_roi_fisheye_frame(camera_name)
  {
    let camera_el = $(`.menu__cameras-camera-roi[data-name='${camera_name}']`);

    $(camera_el).find('.menu__cameras-camera-image-img').addClass('invisible');
  }

  update()
  {
    // Monitor if any menus are open then move the menu icon
    if (this.app.pharos_view && this.app.pharos_view.is_opened) {
      this.open_button.css('right', `-440px`);
    } else if (this.app.uav_view && this.app.uav_view.is_opened) {
      this.open_button.css('right', `-440px`);
    } else {
      this.open_button.css('right', `-70px`);
    }

    // ios let height = $('.menu__cameras-camera-image-img').width();
    // $('.menu__cameras-camera-image').css('min-height', height);

    let menu_cameras = document.querySelectorAll('.menu__cameras-camera-image');

    for (let i = 0; i < menu_cameras.length; i++)
    {
      const height = menu_cameras[i].querySelector('.menu__cameras-camera-image-img').getBoundingClientRect().height;
      menu_cameras[i].style.height = `${height - 4}px`;
    }
  }

  is_mode_active(mode)
  {
    return (app.menu_view.current_tab.name === mode);
  }

  hide_options()
  {
    this.options_button.addClass('hidden');
  }

  show_options()
  {
    this.options_button.removeClass('hidden');
  }

  hide_live_tab()
  {
    this.tabs_tab_live.addClass('hidden');
  }

  hide_recordings_tab()
  {
    this.tabs_tab_recordings.addClass('hidden');
  }

  hide_archive_tab()
  {
    this.tabs_tab_archive.addClass('hidden');
  }

  hide_events_tab()
  {
    this.tabs_tab_events.addClass('hidden');
  }

  __on_mouse_down(e)
  {
    let origin = this.menu_handle.position().left;
    let touch = e.originalEvent.touches;
    let start = touch ? touch[0].pageX : e.pageX;

    $(window).on('mousemove touchmove', this.__on_mouse_move.bind(this, origin, touch, start));
    $(window).one('mouseup touchend', this.__on_mouse_up.bind(this));

    e.preventDefault();
  }

  __on_mouse_move(origin, touch, start, e)
  {
    let contact = e.originalEvent.touches;
    let end = touch ? contact[0].pageX : e.pageX;
    let difference = end - start;

    let newleft = Math.max(0, origin + difference);

    let newwidth = newleft + 35;

    this.menu_handle.css('left', newleft);
    this.container.css('width', newwidth);
  }

  __on_mouse_up(e)
  {
    e.preventDefault();
    $(window).off('mousemove touchmove');
    localStorage.setItem('menu_width', this.container.width());
  }

  __toggle_switch_elem(elem, should_activate)
  {
    if (should_activate)
    {
      $(elem).addClass('active');
    }
    else
    {
      $(elem).removeClass('active');
    }
  }
}
